<template>
  <yv-form-search
    :formSearch="formSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formSearch"
  ></yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { getId } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import { EVENT_TYPES } from "../Event/event-utils";
import { mapGetters } from "vuex";
import { DEFAULT_OPTION_ALL } from "@/constants";

export default {
  name: "counselor-search-bar",
  components: { YvFormSearch },
  inject: ["refetchEvents"],
  data() {
    const eventTypeOpts = [
      ...DEFAULT_OPTION_ALL,
      {
        id: EVENT_TYPES.schoolEvent,
        name: this.$t("schedule.school_event")
      },
      {
        id: EVENT_TYPES.classEvent,
        name: this.$t("schedule.class_schedule")
      },
      {
        id: EVENT_TYPES.meetingEvent,
        name: this.$t("schedule.virtual_meeting")
      }
    ];
    return {
      formSearch: [
        {
          label: this.$t("schedule.teacher_filter_event_type"),
          name: "type",
          value: "",
          options: eventTypeOpts,
          type: "select"
        }
      ]
    };
  },
  watch: {
    "formSearch.0.value": function(newSelectedEventType) {
      if (this.formSearch.length >= 2) {
        this.removeSecondFilteringField();
      }

      const isClassScheduleFiltering =
        newSelectedEventType === EVENT_TYPES.classEvent ||
        newSelectedEventType === EVENT_TYPES.meetingEvent;
      if (isClassScheduleFiltering) {
        this.appendFilterByStudentField();
      }
    }
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info"
    })
  },
  methods: {
    search() {
      this.refetchEvents();
    },
    fetchStudents() {
      const counselorId = getId(this.userInfo);

      return this.$axios
        .get(`${service_paths.users}/${counselorId}/assigned-students`)
        .then(response => {
          const options = response?.data?.data.map(studentInfo => ({
            id: getId(studentInfo),
            name: this.generateStudentOptName(studentInfo)
          }));
          return [...DEFAULT_OPTION_ALL, ...options];
        });
    },
    generateStudentFilter(options) {
      return {
        label: this.$t("schedule.teacher_filter_student_event"),
        name: "student_id",
        value: options[0]?.id,
        options,
        type: "select"
      };
    },
    async appendFilterByStudentField() {
      const students = await this.fetchStudents();
      const filterByClassField = this.generateStudentFilter(students);

      return (this.formSearch = [...this.formSearch, filterByClassField]);
    },
    removeSecondFilteringField() {
      this.formSearch.splice(1);
    },
    getQueryParams() {
      return this.$refs.formSearch.getQueryParams();
    },
    generateStudentOptName(student) {
      const subfixName = student.student_code
        ? ` - ${student.student_code}`
        : "";

      return `${student.full_name}${subfixName}`;
    }
  }
};
</script>
